export enum MandateStatus {
  NEW = 'NEW',

  OPEN = 'OPEN',

  PENDING = 'PENDING',

  BANK_SELECTED = 'BANK_SELECTED',

  SUCCESS = 'SUCCESS',

  SUCCESS_MANUAL = 'SUCCESS_MANUAL',

  CANCELLED = 'CANCELLED',

  EXPIRED = 'EXPIRED',

  FAILURE = 'FAILURE',
}
